import { createTracker } from 'usage-tracker';
import { useMemo } from 'react';
import { usePortalType } from './usePortalType';
const usageTracker = createTracker({
  standalone: true
});
export const trackUserPropertyChange = (numberOfUserProperties, portalType) => {
  usageTracker.track('Crm Object Board', 'Card Interaction', {
    screen: 'properties',
    portalType,
    action: numberOfUserProperties.toString(),
    type: 'user',
    subscreen: 'save'
  });
};
export const trackAssociationLabelChange = (label, portalType) => {
  usageTracker.track('Crm Object Board', 'Card Interaction', {
    screen: 'associations',
    portalType,
    action: label,
    subscreen: 'save'
  });
};
export const useUsageTracking = () => {
  const portalType = usePortalType();
  return useMemo(() => {
    return {
      trackAdminOpenSettings: (source = 'other') => {
        usageTracker.track('Crm Object Board', 'Card Interaction', {
          screen: 'card settings',
          portalType,
          subscreen: source,
          action: 'open',
          type: 'admin'
        });
      },
      trackUserOpenSettings: (source = 'other') => {
        usageTracker.track('Crm Object Board', 'Card Interaction', {
          screen: 'card settings',
          portalType,
          action: 'open',
          type: 'user',
          subscreen: source
        });
      },
      trackQuickActionClicked: action => {
        usageTracker.track('Crm Object Board', 'Card Interaction', {
          screen: 'quick actions',
          portalType,
          action: 'click',
          subscreen: action
        });
      },
      trackTitleClicked: objectTypeId => {
        usageTracker.track('Crm Object Board', 'Card Interaction', {
          screen: 'card section',
          portalType,
          action: 'click',
          subscreen: 'title',
          objectTypeId
        });
      },
      trackExpandClicked: (objectTypeId, sectionName) => {
        usageTracker.track('Crm Object Board', 'Card Interaction', {
          screen: 'card section',
          portalType,
          action: 'click',
          subscreen: 'expand',
          objectTypeId,
          type: sectionName
        });
      },
      trackColumnCollapseChange: collapsed => {
        usageTracker.track('Crm Object Board', 'Board Interaction', {
          screen: 'board column collapse',
          action: collapsed ? 'collapse' : 'expand'
        });
      },
      trackColumnChange: (objectTypeId, columnId) => {
        usageTracker.track('Crm Object Board', 'Board Interaction', {
          screen: 'board column change',
          objectTypeId,
          type: columnId
        });
      },
      trackNavigationToRecordsPage: objectTypeId => {
        usageTracker.track('Crm Object Board', 'Board Interaction', {
          screen: 'navigation to records page',
          objectTypeId
        });
      },
      trackPreviewSideBarTriggered: objectTypeId => {
        usageTracker.track('Crm Object Board', 'Board Interaction', {
          screen: 'preview side bar triggered',
          objectTypeId
        });
      },
      trackBoardBulkAction: action => {
        usageTracker.track('Crm Object Board', 'Board Interaction', {
          screen: 'board bulk action',
          action
        });
      }
    };
  }, [portalType]);
};